import config from './config'
import {
  countries,
  states,
  EventBus,
  DataFilter,
  parseNumber,
  forceUpdateOnResize,
  coerceBoolean,
  pushState,
  formatPrice,
  alert,
  fv,
  fo,
  fs,
  fn
} from 'utils/vue/lib/utils'

export {countries,
  states,
  EventBus,
  DataFilter,
  parseNumber,
  forceUpdateOnResize,
  coerceBoolean,
  pushState,
  formatPrice,
  alert,
  fv,
  fo,
  fs,
  fn
}

export const {DateTime, Settings} = require('luxon')
Settings.defaultLocale = 'en-us'

export const isInteger = (val, min = 0) => val >= min && parseInt(val) === parseNumber(val)

export const getQS = () => {
  let qs = {}
  let search = (window.location.search || '').replace(/^\?/, '') + '&'
  search = _.filter(search.split('&'))
  search.map((item) => {
    const parts = item.split('=')
    qs[parts[0]] = parts[1] || true
  })
  return qs
}

export const get$ = (selector, p = document) => p.querySelector(selector)

export const style$ = (styles, selector, p = document) => {
  const el = get$(selector, p)
  if (el && el.style) {
    _.forOwn(styles, (value, key) => {
        el.style[key] = value
    })
  }
}

export const html$ = (html, selector, p = document) => {
  const el = get$(selector, p)
  if (el) {
      el.innerHTML = html
  }
}

